export default __webpack_public_path__ + "assets/images/12d95f2e3fb6487e342982525bd226bc.png";